import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false
})
export class ProgressBarComponent {
  constructor() {}

  @Input() progress = 0;
  @Input() errored: boolean;
  @Input() barColor: string;

  getOverrideBarColor(): string | null {
    if (this.barColor && this.barColor !== '') {
      return this.barColor;
    } else {
      return null;
    }
  }
}
